/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TTLOFormConfiguration,
    TTLOFormConfigurationFromJSON,
    TTLOFormConfigurationToJSON,
    TTLOFormData,
    TTLOFormDataFromJSON,
    TTLOFormDataToJSON,
    TTLOListItem,
    TTLOListItemFromJSON,
    TTLOListItemToJSON,
    TTLOValidationData,
    TTLOValidationDataFromJSON,
    TTLOValidationDataToJSON,
} from '../models';

export interface ApiTicketTLOV2TTLOV2FormCreatePostRequest {
    tTLOFormData?: TTLOFormData;
}

export interface ApiTicketTLOV2TTLOV2FormDeleteDeleteRequest {
    id?: string;
}

export interface ApiTicketTLOV2TTLOV2FormGetByIdGetRequest {
    id?: string;
}

export interface ApiTicketTLOV2TTLOV2FormUpdatePostRequest {
    tTLOFormData?: TTLOFormData;
}

export interface ApiTicketTLOV2TTLOV2FormValidatePostRequest {
    tTLOFormData?: TTLOFormData;
}

/**
 * no description
 */
export class TTLOV2FormApi extends runtime.BaseAPI {

    /**
     */
    async apiTicketTLOV2TTLOV2FormCreatePostRaw(requestParameters: ApiTicketTLOV2TTLOV2FormCreatePostRequest): Promise<runtime.ApiResponse<TTLOListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TTLOFormDataToJSON(requestParameters.tTLOFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormCreatePost(requestParameters: ApiTicketTLOV2TTLOV2FormCreatePostRequest): Promise<TTLOListItem> {
        const response = await this.apiTicketTLOV2TTLOV2FormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormDeleteDeleteRaw(requestParameters: ApiTicketTLOV2TTLOV2FormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormDeleteDelete(requestParameters: ApiTicketTLOV2TTLOV2FormDeleteDeleteRequest): Promise<void> {
        await this.apiTicketTLOV2TTLOV2FormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormFormConfigurationGetRaw(): Promise<runtime.ApiResponse<TTLOFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/FormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormFormConfigurationGet(): Promise<TTLOFormConfiguration> {
        const response = await this.apiTicketTLOV2TTLOV2FormFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormGetByIdGetRaw(requestParameters: ApiTicketTLOV2TTLOV2FormGetByIdGetRequest): Promise<runtime.ApiResponse<TTLOFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormGetByIdGet(requestParameters: ApiTicketTLOV2TTLOV2FormGetByIdGetRequest): Promise<TTLOFormData> {
        const response = await this.apiTicketTLOV2TTLOV2FormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormUpdatePostRaw(requestParameters: ApiTicketTLOV2TTLOV2FormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TTLOFormDataToJSON(requestParameters.tTLOFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormUpdatePost(requestParameters: ApiTicketTLOV2TTLOV2FormUpdatePostRequest): Promise<void> {
        await this.apiTicketTLOV2TTLOV2FormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormValidatePostRaw(requestParameters: ApiTicketTLOV2TTLOV2FormValidatePostRequest): Promise<runtime.ApiResponse<TTLOValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2Form/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TTLOFormDataToJSON(requestParameters.tTLOFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2FormValidatePost(requestParameters: ApiTicketTLOV2TTLOV2FormValidatePostRequest): Promise<TTLOValidationData> {
        const response = await this.apiTicketTLOV2TTLOV2FormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
